$( document ).ready(function() {

  var winWidth = $(window).width();

  $('.team-item').on('click', function(e) {

    e.preventDefault();

    $('.team-item').removeClass('is-showing');
    $(this).addClass('is-showing');

    if ( winWidth < 992 ) {

      var elOffset = $(this).offset();
      var elOffsetTop = elOffset.top;

      $('html, body').animate({
        scrollTop: elOffsetTop
      }, 750);

    }

  });

  // Add class to body on hamburger click
  $('.navbar-toggler').on('click', function(e) {
    e.preventDefault();
    $('body').toggleClass('menu-is-open');
  });

  if ( $('.page--featured-image').length > 0 ) {

    var mobileImage = $('.page--featured-image').data('mobile');

    if ( winWidth < 992 && mobileImage ) {
      $('.page--featured-image').attr('style', mobileImage);
    }

  }

  $('.ginput_container input:not(:file), .ginput_container textarea').on('focusout', function(e) {

    var thisVal = $(this).val();

    if (thisVal) {
      $(this).parent().addClass('has-value');
    } else {
      $(this).parent().removeClass('has-value');
    }

  });

  if ( $('.masthead--content').length > 0 ) {

    var mobileImage = $('.masthead--content').data('mobile');
    var desktopImage = $('.masthead--content').data('desktop');

    if ( winWidth < 1200 && mobileImage ) {
      $('.masthead--content').attr('style', mobileImage).addClass('over');
    } else {
      $('.masthead--content').attr('style', desktopImage).addClass('over');
    }

  }

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode ? 'is-ie' : 'is-not-ie';

  $('html').removeClass('no-js').addClass('is-loaded').addClass(isIE11);

  // Detect if banner has been scrolled past
  var navScrolled = function() {

    var $window    = $(window);
    var docViewTop = 90;
    var nav        = $('.banner');
    var elemTop    = $window.scrollTop();

    if ( elemTop > docViewTop ) {
      nav.addClass('scrolled');
    } else {
      nav.removeClass('scrolled');
    }

  };

  navScrolled();

  $( window ).scroll( function(e) {
    navScrolled();
  });

  if ( $('.blank').length > 0 ) {

    $('.blank').each( function(index, value) {
      $(this).find('a').attr('target','_blank').attr('rel','external noreferrer noopener');
    });

  }

});
